/**
 * Hoe oud de gegevens van een externe bron zijn, in woorden.
 *
 * Bestaat omdat het paneel dit niet toonde en de stilte daardoor onzichtbaar
 * was. Gemeten op de live server, 24 augustus 2026: élke NDW-rij en élke
 * OSM-camera droeg `last_synced_at` 2026-08-15T12:55 — één en dezelfde minuut,
 * negen dagen oud. Eén handmatige run, en daarna niets. Het paneel had een
 * knop "Nu ophalen" en verder geen enkele aanwijzing dat er sindsdien niets
 * meer was gebeurd.
 *
 * Een etmaal is de grens. Beide bronnen horen minstens dagelijks te lopen —
 * de flitspalen om vier uur, de werkzaamheden elke vier uur — dus alles boven
 * de vierentwintig uur betekent dat er iets niet draait.
 */
export const STALE_HOURS = 24;

/**
 * @param {object|null} bron  één ingang uit /admin/external/status → sources
 * @returns {{tekst: string, oud: boolean, leeg: boolean}}
 */
export const syncAge = (bron) => {
  if (!bron || !bron.count) {
    // Nul is een antwoord en geen fout: op dag één is er nog niets ingelezen.
    return { tekst: "Nog niets ingelezen.", oud: false, leeg: true };
  }
  const uren = bron.age_hours;
  if (uren === null || uren === undefined) {
    // Rijen zonder leesbaar tijdstempel. Niet groen kleuren: we weten het niet,
    // en "onbekend" hoort niet als "in orde" te lezen.
    return { tekst: "onbekend wanneer", oud: true, leeg: false };
  }
  if (uren < 1) return { tekst: "zojuist bijgewerkt", oud: false, leeg: false };
  if (uren < 48) {
    return {
      tekst: `bijgewerkt ${Math.round(uren)} uur geleden`,
      oud: uren > STALE_HOURS,
      leeg: false,
    };
  }
  return {
    tekst: `bijgewerkt ${Math.round(uren / 24)} dagen geleden`,
    oud: true,
    leeg: false,
  };
};
